export default "__VITE_PUBLIC_ASSET__b5aa2963__"